<div class="date-filter-container mb-0">
    <div class="date-filter-header">
        <div class="date-nav-with-label">
            <button type="button" class="btn date-nav-btn" (click)="decrementDate()" rippleEffect>
                <i data-feather="chevron-left"></i>
            </button>
            <button type="button" class="btn date-nav-btn" (click)="incrementDate()" rippleEffect>
                <i data-feather="chevron-right"></i>
            </button>
            <p class="date-display">{{ selectedPeriod || '' }}</p>
        </div>
    </div>
    <div class="date-filter-buttons">
        <div class="btn-group" role="group">
            <button type="button" class="btn bouttons" rippleEffect (click)="changeViewMode('jours');"
                    [class.active]="viewMode==='jours'">
                <p>Jours</p>
            </button>
            <button type="button" class="btn bouttons" rippleEffect (click)="changeViewMode('mois');"
                    [class.active]="viewMode==='mois'">
                <p>Mois</p>
            </button>
            <button type="button" class="btn bouttons" rippleEffect (click)="changeViewMode('annees');"
                    [class.active]="viewMode==='annees'">
                <p>Année</p>
            </button>
            <button class="btn bouttons" rippleEffect (click)="openFlatpickr(); $event.preventDefault()"
                    style="color: rgba(19, 74, 211, 1);">
                <i data-feather="calendar"></i>
            </button>
        </div>
        <input type="text" #datePicker class="flatpickr-input" style="margin-top: 40px;"/>
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'jours'">
    <div class="data-list-wrapper">
        <div *ngFor="let day of weekDays"
             (click)="selectDay(day)"
             [class.selected]="day.dateString === selectedDay"
             [class.today]="day.isToday"
             class="day-item">
            {{ day.label }}
        </div>
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'mois'">
    <div class="data-list-wrapper">
        <div *ngFor="let month of months; let i=index"
             (click)="selectMonth(i)"
             [class.selected]="i === selectedMonthIndex"
             [class.today]="i === currentMonthIndex"
             class="month-item">
            {{ month }}
        </div>
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'annees'">
    <div class="data-list-wrapper">
        <div *ngFor="let year of years"
             (click)="selectYear(year)"
             [class.selected]="year === selectedYear"
             [class.today]="year === currentYear"
             class="year-item">
            {{ year }}
        </div>
    </div>
</div>

<!-- Même gabarit que shared.component : barre d’outils, tableau, pagination -->
<app-document-list-progress></app-document-list-progress>

<div class="d-flex" style="position: relative;">
    <div class="card-body row m-0 align-items-center flex-wrap" style="padding: 24px">
        <div class="input-group form-password-toggle d-flex" style="width: 300px;">
            <input
                    type="text"
                    class="form-control"
                    placeholder="Recherche par mot clé"
                    aria-label="Search..."
                    aria-describedby="basic-addon-search-pos"
                    [(ngModel)]="searchTerm"
                    (ngModelChange)="onSearch()"
            />
            <div class="input-group-append" style="margin-right: 10px;">
                <span class="input-group-text" id="basic-addon-search-pos" style="color: black;">
                    <i data-feather="search" [size]="20"></i>
                </span>
            </div>
        </div>

        <button type="button" class="btn btn-outline-primary btn-icon" (click)="toggleFilter()" rippleEffect style="padding: 11px 11px !important;">
            <span data-feather="filter"></span>
        </button>

        <ng-select
                class="pos-toolbar-ng-select"
                [items]="establishmentOptions"
                bindLabel="label"
                bindValue="id"
                [multiple]="true"
                [closeOnSelect]="false"
                [clearable]="true"
                [searchable]="true"
                placeholder="Établissement"
                [(ngModel)]="selectedEstablishmentIds"
                (ngModelChange)="onEstablishmentFilterChange()"
                (open)="onEstablishmentDropdownOpen()"
                (close)="onEstablishmentDropdownClose()"
                appendTo="body">
        </ng-select>

        <ng-select
                class="pos-toolbar-ng-select"
                [items]="filteredWarehouseOptions"
                bindLabel="label"
                bindValue="id"
                [multiple]="true"
                [closeOnSelect]="false"
                [clearable]="true"
                [searchable]="true"
                placeholder="Entrepôt"
                [(ngModel)]="selectedWarehouseIds"
                (ngModelChange)="onWarehouseFilterChange()"
                (open)="onWarehouseDropdownOpen()"
                (close)="onWarehouseDropdownClose()"
                appendTo="body">
        </ng-select>

        <ng-select
                class="pos-toolbar-ng-select pos-toolbar-ng-select-payment"
                [items]="paymentTypeFilterOptions"
                bindLabel="label"
                bindValue="value"
                [multiple]="true"
                [closeOnSelect]="false"
                [clearable]="true"
                [searchable]="false"
                placeholder="Type de paiement"
                [(ngModel)]="selectedPaymentTypes"
                (ngModelChange)="onPaymentTypeFilterChange()"
                (open)="onPaymentTypeDropdownOpen()"
                (close)="onPaymentTypeDropdownClose()"
                appendTo="body">
        </ng-select>

        <div class="active-filters-container d-flex flex-wrap align-items-center gap-2" style="margin-left: 12px;"
             *ngIf="getActiveFilters().length > 0">
            <div *ngFor="let filter of getActiveFilters(); trackBy: trackByFilterKey" class="filter-badge">
                <span class="filter-badge-label">{{ filter.label }}:</span>
                <span class="filter-badge-value">{{ filter.value }}</span>
                <button type="button" class="filter-badge-close"
                        (click)="removeFilter(filter.key, $event); $event.stopPropagation(); $event.preventDefault()"
                        aria-label="Supprimer le filtre">
                    <i data-feather="x" style="width: 12px; height: 12px;"></i>
                </button>
            </div>
        </div>
    </div>

    <div class="card filter-sidebar length" *ngIf="showFilter"
         style="max-height: 540px; box-shadow: 0 4px 18px rgba(47, 43, 61, 0.16);">
        <div class="card-header d-flex justify-content-between align-items-center" style="margin-top: 2px;">
            <h4 class="card-title mb-0">Filtres</h4>
            <button type="button" class="btn btn-sm btn-icon btn-light" (click)="closeFilterPanel()" aria-label="Fermer">
                <i class="bx bx-x"></i>
            </button>
        </div>
        <div class="card-body d-flex flex-column p-1 filter-sidebar-body">
            <div class="flex-grow-1 overflow-auto pe-1">
                <div class="mb-2">
                    <label class="form-label" for="posEstablishmentSelect">Établissement</label>
                    <ng-select
                            id="posEstablishmentSelect"
                            class="filter-ng-select"
                            dropdownClass="pos-filter-sidebar-dropdown"
                            [items]="establishmentOptions"
                            bindLabel="label"
                            bindValue="id"
                            [clearable]="true"
                            [searchable]="true"
                            [multiple]="true"
                            placeholder="Tous les établissements"
                            [(ngModel)]="selectedEstablishmentIds"
                            (ngModelChange)="onEstablishmentFilterChange()"
                            (open)="onEstablishmentDropdownOpen()"
                            (close)="onEstablishmentDropdownClose()"
                            [closeOnSelect]="false"
                            appendTo="body">
                    </ng-select>
                </div>
                <div class="mb-2">
                    <label class="form-label" for="posWarehouseSelect">Entrepôt</label>
                    <ng-select
                            id="posWarehouseSelect"
                            class="filter-ng-select"
                            dropdownClass="pos-filter-sidebar-dropdown"
                            [items]="filteredWarehouseOptions"
                            bindLabel="label"
                            bindValue="id"
                            [clearable]="true"
                            [searchable]="true"
                            [multiple]="true"
                            placeholder="Tous les entrepôts"
                            [(ngModel)]="selectedWarehouseIds"
                            (ngModelChange)="onWarehouseFilterChange()"
                            (open)="onWarehouseDropdownOpen()"
                            (close)="onWarehouseDropdownClose()"
                            [closeOnSelect]="false"
                            appendTo="body">
                    </ng-select>
                </div>
                <div class="mb-2">
                    <label class="form-label" for="posPaymentTypeSelect">Type de paiement</label>
                    <ng-select
                            id="posPaymentTypeSelect"
                            class="filter-ng-select"
                            dropdownClass="pos-filter-sidebar-dropdown"
                            [items]="paymentTypeFilterOptions"
                            bindLabel="label"
                            bindValue="value"
                            [clearable]="true"
                            [searchable]="false"
                            [multiple]="true"
                            placeholder="Tous les paiements"
                            [(ngModel)]="selectedPaymentTypes"
                            (ngModelChange)="onPaymentTypeFilterChange()"
                            (open)="onPaymentTypeDropdownOpen()"
                            (close)="onPaymentTypeDropdownClose()"
                            [closeOnSelect]="false"
                            appendTo="body">
                    </ng-select>
                </div>
                <div class="mb-2" *ngIf="showTicketTypeFilter">
                    <label class="form-label" for="posTicketTypeSelect">Type de ticket</label>
                    <ng-select
                            id="posTicketTypeSelect"
                            class="filter-ng-select"
                            dropdownClass="pos-filter-sidebar-dropdown"
                            [items]="ticketTypeFilterOptions"
                            bindLabel="label"
                            bindValue="value"
                            [clearable]="true"
                            [searchable]="false"
                            [multiple]="true"
                            placeholder="Tous les types"
                            [(ngModel)]="selectedTicketTypes"
                            [closeOnSelect]="false"
                            appendTo="body">
                    </ng-select>
                </div>
                <div class="mb-2">
                    <label class="form-label" for="posTicketStatutSelect">Statut ticket</label>
                    <ng-select
                            id="posTicketStatutSelect"
                            class="filter-ng-select"
                            dropdownClass="pos-filter-sidebar-dropdown"
                            [items]="ticketStatutFilterOptions"
                            bindLabel="label"
                            bindValue="value"
                            [clearable]="true"
                            [searchable]="false"
                            [multiple]="true"
                            placeholder="Tous les statuts"
                            [(ngModel)]="selectedTicketStatuts"
                            [closeOnSelect]="false"
                            appendTo="body">
                    </ng-select>
                </div>
                <div class="mb-2">
                    <label class="form-label" for="posTotalFilterOp">Total ticket</label>
                    <div class="pos-total-filter-row">
                        <select
                                id="posTotalFilterOp"
                                class="custom-select pos-total-filter-op"
                                [(ngModel)]="totalFilterOperator">
                            <option value="">Tous</option>
                            <option *ngFor="let op of totalFilterOperatorOptions" [value]="op.value">
                                {{ op.label }}
                            </option>
                        </select>
                        <input
                                id="posTotalFilterValue"
                                type="number"
                                class="form-control pos-total-filter-value"
                                [(ngModel)]="totalFilterValue"
                                placeholder="Montant"
                                step="0.001"
                                min="0"
                                [disabled]="!totalFilterOperator" />
                        <input
                                *ngIf="totalFilterOperator === 'between'"
                                id="posTotalFilterValueMax"
                                type="number"
                                class="form-control pos-total-filter-value"
                                [(ngModel)]="totalFilterValueMax"
                                placeholder="Max"
                                step="0.001"
                                min="0" />
                    </div>
                    <small class="text-muted" *ngIf="totalFilterOperator === 'between'">
                        Montant minimum et maximum (DT).
                    </small>
                </div>
            </div>
            <div class="pt-2 d-flex justify-content-end gap-1">
                <button type="button" class="btn btn-outline-secondary" (click)="resetFilters()" style="margin-right: 15px;">
                    Réinitialiser
                </button>
                <button type="button" class="btn btn-primary" (click)="applyFilters()">Appliquer</button>
            </div>
        </div>
    </div>
</div>

<div class="table-full-width">
    <div class="table-responsive pos-ticket-table-wrap" style="height: 700px">
        <table class="table table-hover pos-ticket-table" [class.pos-ticket-table--loading]="isTableLoading">
            <thead class="custom-header">
            <tr>
                <th class="pos-ticket-table__th-check" style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 4%;">
                    <div class="pos-check form-check m-0">
                        <input #selectAllCheckbox class="form-check-input" type="checkbox"
                               [checked]="allPageSelected"
                               (change)="toggleSelectAllOnPage($any($event.target).checked)"
                               aria-label="Tout sélectionner sur la page"/>
                    </div>
                </th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 12%">{{ listNumeroColumnLabel }}</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 12%">TYPE</th>
                <th *ngIf="showClotureColumn" style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 8%">CLÔTURE</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 7%">SOURCE</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 8%">DATE</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 14%">CLIENT</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 10%">ENTREPÔT</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 10%">STATUT PAIEMENT</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 10%">MODE PAIEMENT</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 8%">MONTANT PAYÉ</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 10%">STATUT TICKET</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 200px">ACTIONS</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngIf="isTableLoading || (!hasDataLoaded && paginatedData.length === 0)">
                <td [attr.colspan]="ticketTableColspan" class="p-0 border-0">
                    <div class="erp-table-skeleton" *ngIf="isTableLoading">
                        <div class="erp-table-skeleton__row" *ngFor="let _ of skeletonRows">
                            <span class="erp-table-skeleton__cell erp-table-skeleton__cell--check"></span>
                            <span class="erp-table-skeleton__cell erp-table-skeleton__cell--ref"></span>
                            <span class="erp-table-skeleton__cell erp-table-skeleton__cell--short"></span>
                            <span class="erp-table-skeleton__cell erp-table-skeleton__cell--short"></span>
                            <span class="erp-table-skeleton__cell erp-table-skeleton__cell--short"></span>
                            <span class="erp-table-skeleton__cell"></span>
                            <span class="erp-table-skeleton__cell"></span>
                            <span class="erp-table-skeleton__cell erp-table-skeleton__cell--short"></span>
                            <span class="erp-table-skeleton__cell erp-table-skeleton__cell--short"></span>
                            <span class="erp-table-skeleton__cell erp-table-skeleton__cell--badge"></span>
                            <span class="erp-table-skeleton__cell erp-table-skeleton__cell--actions"></span>
                        </div>
                    </div>
                </td>
            </tr>
            <ng-container *ngIf="!isTableLoading && hasDataLoaded">
            <tr *ngFor="let item of paginatedData; trackBy: trackByTicketId"
                class="pos-ticket-table__row-selectable"
                (click)="onTicketRowClick($event, item)">
                <td class="pos-ticket-table__td-check">
                    <div class="pos-check form-check m-0">
                        <input class="form-check-input" type="checkbox"
                               [checked]="isTicketSelected(item.id)"
                               (change)="toggleTicketSelection(item.id, $any($event.target).checked)"
                               [attr.aria-label]="'Sélectionner ' + item.numero"/>
                    </div>
                </td>
                <td>
                    <a class="ref d-flex align-items-center cursor-pointer hover-bg-light"
                       href="javascript:void(0)"
                       (click)="$event.preventDefault(); $event.stopPropagation(); onViewTicket(item)">
                        {{ item.numero }}
                    </a>
                </td>
                <td style="font-size: 12px; color: rgba(47, 43, 61, 0.85);">
                    {{ displaySousTypeLabel(item) }}
                    <i *ngIf="isTickeTermine(item)"
                       class="bx bx-check pos-ticket-termine-icon"
                       title="Terminé"
                       aria-label="Terminé"></i>
                </td>
                <td *ngIf="showClotureColumn" style="font-size: 12px; color: rgba(47, 43, 61, 0.85);">{{ displayClotureLabel(item) }}</td>
                <td style="font-size: 13px; color: rgba(47, 43, 61, 0.85);">{{ item.origineLabel || '—' }}</td>
                <td style="font-size: 13px; color: rgba(47, 43, 61, 0.85);">{{ formatTicketDate(item.date) }}</td>
                <td>
                    <span class="size15" style="display: block;">{{ item.clientName }}</span>
                    <span class="phone-number">{{ item.clientPhone }}</span>
                </td>
                <td style="font-size: 13px;">{{ item.entrepot }}</td>
                <td>
                    <div class="status-badge-wrapper">
          <span [ngClass]="getPaymentBadgeNgClass(item)">
            {{ paymentStatusLabel(item.paymentStatus) }}
          </span>
                    </div>
                </td>
                <td style="font-size: 13px; color: rgba(47, 43, 61, 0.85);">
                    {{ item.paymentModesLabel || '—' }}
                </td>
                <td style="font-size: 13px; color: rgba(47, 43, 61, 0.85);">{{ formatMoneyTnd(item.ticketTotal ?? 0) }}</td>
                <td>
                    <div class="status-badge-wrapper">
          <span [ngClass]="getDocumentStatutBadgeNgClass(item)">
            <i *ngIf="isDocumentTermine(item)"
               class="bx bx-check pos-ticket-termine-icon"
               aria-hidden="true"></i>
            {{ displayDocumentStatutLabel(item) }}
          </span>
                    </div>
                </td>
                <td class="action-icons d-flex align-items-center">
                    <a class="me-2 action-icon" href="javascript:void(0)"
                       (click)="onViewTicket(item); $event.preventDefault(); $event.stopPropagation()"
                       title="Voir"
                       style="color: rgba(47, 43, 61, 0.7); margin-right: 30px; width: 20px; height: auto">
                        <span data-feather="eye" [size]="20"></span>
                    </a>
                    <a
                        *ngIf="showPassationToCaisseAction(item)"
                        class="me-2 action-icon"
                        href="javascript:void(0)"
                        (click)="openPassationModal(item); $event.preventDefault(); $event.stopPropagation()"
                        title="Passer en caisse"
                        style="color: rgba(19, 74, 211, 1); margin-right: 30px; width: 20px; height: auto">
                        <span data-feather="send" [size]="20"></span>
                    </a>
                    <a
                        *ngIf="showClotureInitialisationAction(item)"
                        class="me-2 action-icon"
                        href="javascript:void(0)"
                        (click)="clotureInitialisation(item); $event.preventDefault(); $event.stopPropagation()"
                        title="Clôturer (sans passer en tické)"
                        [attr.aria-disabled]="clotureSubmitting"
                        style="color: rgba(40, 167, 69, 1); margin-right: 30px; width: 20px; height: auto">
                        <span data-feather="check-circle" [size]="20"></span>
                    </a>
                    <a
                        *ngIf="showTransferToFactureAction(item)"
                        class="me-2 action-icon"
                        href="javascript:void(0)"
                       (click)="openConvertModal(item); $event.preventDefault(); $event.stopPropagation()"
                       title="Passer à facture"
                       style="color: rgba(19, 74, 211, 1); margin-right: 30px; width: 20px; height: auto">
                        <span data-feather="repeat" [size]="20"></span>
                    </a>

                    <a class="me-2 action-icon" href="javascript:void(0)"
                       (click)="openAnnulerTicketModal(item); $event.preventDefault(); $event.stopPropagation()"
                       title="Annuler"
                       *ngIf="showCancelTicketAction(item)"
                       style="color: rgba(255, 76, 81, 1); margin-right: 30px; width: 20px; height: auto">
                        <span data-feather="x-circle" [size]="20"></span>
                    </a>
                </td>
            </tr>
            <tr *ngIf="paginatedData.length === 0">
                <td [attr.colspan]="ticketTableColspan" class="text-center" style="padding: 3rem;">
                    <div class="d-flex flex-column align-items-center justify-content-center">
                        <p class="mb-0" style="text-align: center; font-weight: 700; color: #6e6e6e;font-size: 15px">
                            Pas de données à afficher
                        </p>
                    </div>
                </td>
            </tr>
            </ng-container>
            </tbody>
        </table>
    </div>
</div>

<div class="">
    <div class="row d-flex pagination-bar">
        <div class="col-md-3 col-12">
            <div class="d-flex justify-content-between align-items-center">
                <label class="d-flex align-items-center" style="font-size: 15px; margin-left: 24px">
                    Afficher
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption"
                            (ngModelChange)="onPageSizeChange()">
                        <option [ngValue]="10">10</option>
                        <option [ngValue]="25">25</option>
                        <option [ngValue]="50">50</option>
                        <option [ngValue]="100">100</option>
                    </select>
                </label>
            </div>
        </div>
        <div class="col-md-9 col-12 pagination-col">
            <div class="pagination-row d-flex justify-content-end gap-2">
                <div class="page-box" [class.disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(1)">«
                </div>
                <div class="page-box" [class.disabled]="currentPage === 1"
                     (click)="currentPage > 1 && changePage(currentPage - 1)">‹
                </div>
                <div *ngFor="let page of pages" class="page-box" [class.active]="page === currentPage"
                     (click)="changePage(page)">{{ page }}
                </div>
                <div class="page-box" [class.disabled]="currentPage === totalPages"
                     (click)="currentPage < totalPages && changePage(currentPage + 1)">›
                </div>
                <div class="page-box" [class.disabled]="currentPage === totalPages"
                     (click)="currentPage < totalPages && changePage(totalPages)">»
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Panneaux latéraux : détail ticket + ticket lié -->
<div
    class="modal-backdrop pos-ticket-modals-backdrop"
    *ngIf="ticketDetail || detailLoading || originTicketDetail || originDetailLoading"
    (click)="onClose()"
>
    <div class="pos-ticket-modals-row" (click)="onContentClick($event)">

        <!-- Ticket de caisse lié (à gauche du détail principal) -->
        <div class="modal-panel modal-panel--origin" *ngIf="originTicketDetail || originDetailLoading">
            <div class="modal-header modal_head_title">
                <h3>ticket de caisse lié</h3>
                <button type="button" class="close-btn" (click)="onCloseOriginPanel($event)">×</button>
            </div>
            <div *ngIf="originDetailLoading" class="pos-detail-loading text-center py-5" role="status" aria-live="polite">
                <span class="spinner-border text-primary" aria-hidden="true"></span>
                <p class="pos-detail-loading__text mb-0 mt-2">Chargement du ticket lié…</p>
            </div>
            <ng-container *ngIf="originTicketDetail as originVm">
                <ng-container *ngTemplateOutlet="posTicketDetailContent; context: { vm: originVm, showOriginLink: false }"></ng-container>
            </ng-container>
        </div>

        <!-- Détails ticket / initialisation (principal) -->
        <div class="modal-panel" *ngIf="ticketDetail || detailLoading">
            <div class="modal-header modal_head_title">
                <h3>{{ detailPanelTitle(ticketDetail?.ticket) }}</h3>
                <button type="button" class="close-btn" (click)="onClose()">×</button>
            </div>

            <div *ngIf="detailLoading" class="pos-detail-loading text-center py-5" role="status" aria-live="polite">
                <span class="spinner-border text-primary" aria-hidden="true"></span>
                <p class="pos-detail-loading__text mb-0 mt-2">Chargement du détail…</p>
            </div>

            <ng-container *ngIf="ticketDetail as vm">
                <ng-container *ngTemplateOutlet="posTicketDetailContent; context: { vm: vm, showOriginLink: true }"></ng-container>
            </ng-container>

            <div
                class="modal-panel__footer"
                *ngIf="ticketDetail && listContext === 'tickets' && (showPassationToCaisseAction(ticketDetail.ticket) || showClotureInitialisationAction(ticketDetail.ticket) || showTransferToFactureAction(ticketDetail.ticket) || showCancelTicketAction(ticketDetail.ticket))">
                <button
                    type="button"
                    class="btn btn-primary me-2"
                    *ngIf="showPassationToCaisseAction(ticketDetail.ticket)"
                    (click)="openPassationModal(ticketDetail.ticket)"
                    [disabled]="passationSubmitting || clotureSubmitting">
                    Passer en caisse
                </button>
                <button
                    type="button"
                    class="btn btn-outline-secondary me-2"
                    *ngIf="showClotureInitialisationAction(ticketDetail.ticket)"
                    (click)="clotureInitialisation(ticketDetail.ticket)"
                    [disabled]="clotureSubmitting || passationSubmitting">
                    <span *ngIf="clotureSubmitting" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                    Clôturer
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    *ngIf="showTransferToFactureAction(ticketDetail.ticket)"
                    (click)="openConvertModal(ticketDetail.ticket)"
                    [disabled]="transferInProgress">
                    Passer à facture
                </button>
                <button
                    type="button"
                    class="btn btn-outline-danger"
                    *ngIf="showCancelTicketAction(ticketDetail.ticket)"
                    (click)="openAnnulerTicketModal(ticketDetail.ticket)">
                    Annuler
                </button>
            </div>
        </div>
    </div>
</div>

<ng-template #posTicketDetailContent let-vm="vm" let-showOriginLink="showOriginLink">
        <div class="modal-content">
            <div class="section-card">
                <h4 class="section-title-blue">
                    {{ isInitialisationTicket(vm.ticket) ? 'Informations du document' : 'Informations du ticket' }}
                </h4>

                <div class="row-item">
                    <span>{{ isInitialisationTicket(vm.ticket) ? 'Numéro document' : 'Numéro de ticket' }}</span><i class="fa-sharp fa-regular fa-circle-dollar"></i>
                    <strong>{{ vm.ticket.numero }}</strong>
                </div>
                <div class="row-item">
                    <span>Date</span>
                    <strong>{{ formatTicketDate(vm.ticket.date) }}</strong>
                </div>
                <div class="row-item">
                    <span>Établissement</span>
                    <strong>{{ vm.ticket.entrepot }}</strong>
                </div>
                <div class="row-item">
                    <span>Type</span>
                    <span [ngClass]="getDocumentTypeBadgeNgClass(vm.ticket)">
                        {{ displayDocumentTypeLabel(vm.ticket) }}
                        <i *ngIf="isTickeTermine(vm.ticket)"
                           class="bx bx-check pos-ticket-termine-icon"
                           title="Terminé"
                           aria-label="Terminé"></i>
                    </span>
                </div>
                <div class="row-item">
                    <span>Sous-type</span>
                    <strong>{{ displaySousTypeLabel(vm.ticket) }}</strong>
                </div>
                <div class="row-item" *ngIf="vm.ticket.famille === 'initialisation' || vm.ticket.documentType === 'ticket_en_traitement'">
                    <span>Clôture</span>
                    <strong>{{ displayClotureLabel(vm.ticket) }}</strong>
                </div>
                <div class="row-item">
                    <span>Statut ticket</span>
                    <span [ngClass]="getDocumentStatutBadgeNgClass(vm.ticket)">
                        <i *ngIf="isDocumentTermine(vm.ticket)"
                           class="bx bx-check pos-ticket-termine-icon"
                           aria-hidden="true"></i>
                        {{ displayDocumentStatutLabel(vm.ticket) }}
                    </span>
                </div>
                <div class="row-item" *ngIf="vm.ticket.documentOriginal && showOriginLink">
                    <span>Document lié</span>
                    <button
                        type="button"
                        class="btn btn-link p-0 pos-origin-doc-link"
                        [disabled]="!canOpenOriginTicketDetail() || originDetailLoading"
                        (click)="openOriginTicketDetailPanel($event)"
                    >
                        {{ vm.ticket.documentOriginal }}
                    </button>
                </div>
                <div class="row-item" *ngIf="vm.ticket.documentOriginal && !showOriginLink">
                    <span>Document lié</span>
                    <strong>{{ vm.ticket.documentOriginal }}</strong>
                </div>
            </div>

            <div class="grid-2-col">
                <div class="info-card " style="padding: 24px">
                    <div class="card-header p-0">
                        <span class="card-title-blue">Info client</span>
                        <img src="/assets/images/logo/personne.svg" alt="client" class="card-icon">
                    </div>
                    <p class="client-name">{{ vm.ticket.clientName }}</p>
                    <p class="client-info">{{ vm.ticket.clientPhone }}</p>
                </div>

                <div class="info-card" style="padding: 24px">
                    <div class="card-header p-0">
                        <span class="card-title-blue">Info paiement</span>
                        <img src="/assets/images/logo/money9.svg" alt="paiement" class="card-icon">
                    </div>
                    <p class="client-info mb-50">Statut de paiement</p>
                    <p class="client-name mb-1">{{ paymentStatusLabel(vm.ticket.paymentStatus) }}</p>

                    <p class="client-info mb-50 mt-1">Modes de paiement</p>
                    <ng-container *ngIf="vm.paymentModes?.length; else noPaymentMode">
                        <div class="pos-payment-mode-row" *ngFor="let mode of vm.paymentModes">
                            <span class="pos-payment-mode-left">
                              <img
                                *ngIf="paymentModeLogoUrl(mode) as logoSrc"
                                [src]="logoSrc"
                                [alt]="mode.label"
                                class="pos-payment-mode-logo"
                              />
                              <span *ngIf="!paymentModeLogoUrl(mode)" class="pos-payment-mode-letter">{{ paymentModeInitial(mode.label) }}</span>
                              <span class="pos-payment-mode-label">{{ mode.label }}</span>
                            </span>
                            <span class="pos-payment-mode-amount">{{ formatMoneyTnd(mode.amount) }}</span>
                        </div>
                    </ng-container>
                    <ng-template #noPaymentMode>
                        <p class="client-info mt-1">Mode de paiement non renseigné</p>
                    </ng-template>
                </div>
            </div>

            <div class="section-card">
                <h4 class="section-title-blue">Articles</h4>
                <table class="custom-table">
                    <thead>
                    <tr>
                        <th>RÉFÉRENCE</th>
                        <th>COULEUR / TAILLE</th>
                        <th class="text-right">QTÉ</th>
                        <th class="text-right">PRIX UNIT.</th>
                        <th class="text-right">TOTAL</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of vm.lines; trackBy: trackByLineRef">
                        <td>{{ item.reference }}</td>
                        <td>
                            {{ colorSizeMain(item) }}<br *ngIf="colorSizeSub(item)">
                            <small class="text-gray" *ngIf="colorSizeSub(item)">{{ colorSizeSub(item) }}</small>
                        </td>
                        <td class="text-right">{{ item.quantity }}</td>
                        <td class="text-right">{{ formatUnitPrice(item.unitPrice) }}</td>
                        <td class="text-right">{{ formatUnitPrice(item.lineTotal) }}</td>
                    </tr>
                    <tr *ngIf="vm.lines.length === 0">
                        <td colspan="5" class="text-center text-muted py-3">Aucun article</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="section-card">
                <h4 class="section-title-blue">Résumé financier</h4>
                <div class="row-item">
                    <span class="price-total-label">Prix total (réel)</span>
                    <strong class="price-total-value">{{ formatMoneyTnd(vm.totalPrice) }}</strong>
                </div>
                <div class="row-item" *ngIf="showMontantPaye(vm)">
                    <span>Montant payé</span>
                    <strong>{{ formatMoneyTnd(vm.amountPaid) }}</strong>
                </div>
                <div class="row-item" *ngIf="showResteAPayer(vm)">
                    <span>Reste à payer</span>
                    <strong>{{ formatMoneyTnd(vm.resteAPayer ?? resteAPayerOf(vm)) }}</strong>
                </div>
                <div class="row-item">
                    <span>Statut paiement</span>
                    <span [ngClass]="getPaymentBadgeNgClass(vm.ticket)">{{ paymentStatusLabel(vm.ticket.paymentStatus) }}</span>
                </div>
            </div>
        </div>
</ng-template>

<app-convert-tick-caiss
        *ngIf="showConvertModal && ticketToConvert"
        [ticket]="ticketToConvert"
        [defaultDocumentType]="convertModalDefaultType"
        [submitting]="transferInProgress"
        (closed)="closeConvertModal()"
        (convert)="onConvertDocument($event)">
</app-convert-tick-caiss>

<!-- Chargement plein écran pendant le transfert / redirection -->
<div class="pos-transfer-overlay" *ngIf="transferInProgress" role="status" aria-live="polite">
    <div class="pos-transfer-overlay__card">
        <span class="spinner-border text-primary" aria-hidden="true"></span>
        <p class="pos-transfer-overlay__title mb-0">{{ transferLoadingMessage }}</p>
        <p class="pos-transfer-overlay__sub mb-0">Ne fermez pas cette page.</p>
    </div>
</div>

<!-- Annulation ticket (compensatoire, conserve l'historique) -->
<app-annuler-multi-ticket-modal
    *ngIf="showAnnulerModal"
    [ticketIds]="annulerModalTicketIds"
    [isAdmin]="isAdmin"
    [submitting]="cancelSubmitting"
    (closed)="closeAnnulerModal()"
    (confirmCancel)="onConfirmAnnulerTicket($event)"
></app-annuler-multi-ticket-modal>

<!-- Passation ticket → caisse physique (modale centrée) -->
<div
    class="passation-modal-backdrop"
    *ngIf="showPassationModal"
    (click)="closePassationModal()"
    role="dialog"
    aria-modal="true"
    aria-labelledby="passation-modal-title">
    <div class="passation-modal-panel" (click)="onContentClick($event)">
        <div class="passation-modal-header modal_head_title">
            <h3 id="passation-modal-title">Passer en caisse</h3>
            <button type="button" class="close-btn" aria-label="Fermer" (click)="closePassationModal()" [disabled]="passationSubmitting">×</button>
        </div>

        <div class="passation-modal-body">
            <ng-container *ngIf="passationTicket as t">
                <div class="passation-ticket-card">
                    <div class="passation-ticket-card__top">
                        <strong>{{ t.numero }}</strong>
                        <span class="badge badge-light-primary">{{ displayDocumentTypeLabel(t) }}</span>
                    </div>
                    <div class="passation-ticket-card__meta text-muted small">
                        <span *ngIf="t.sousTypeLabel || t.sousType">{{ t.sousTypeLabel || t.sousType }}</span>
                        <span *ngIf="t.entrepot"> · {{ t.entrepot }}</span>
                        <span *ngIf="t.clientName"> · {{ t.clientName }}</span>
                    </div>
                    <div class="passation-ticket-card__total">
                        {{ formatMoneyTnd(t.ticketTotal ?? 0) }}
                    </div>
                    <div class="passation-ticket-card__paid text-muted small mt-1" *ngIf="passationAmountPaid != null && passationAmountPaid > 0">
                        Montant payé : <strong>{{ formatMoneyTnd(passationAmountPaid) }}</strong>
                    </div>
                </div>
            </ng-container>

            <p class="text-muted small mb-3">
                Choisissez la caisse physique qui recevra ce document en temps réel.
                <span *ngIf="passationTicket && isInitialisationTicket(passationTicket)">
                    Vous pouvez aussi <strong>clôturer</strong> l’initialisation sans la passer en tické.
                </span>
            </p>

            <label class="form-label" for="passation-caisse-select">Caisse de destination</label>
            <div *ngIf="passationCaissesLoading" class="passation-loading text-muted small py-2">
                <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                Chargement des caisses…
            </div>
            <select
                *ngIf="!passationCaissesLoading"
                id="passation-caisse-select"
                class="form-select"
                [(ngModel)]="selectedPassationCaisseId"
                [disabled]="passationSubmitting || passationCaisses.length === 0">
                <option [ngValue]="null">— Choisir une caisse —</option>
                <option *ngFor="let c of passationCaisses" [ngValue]="c.id">
                    {{ c.CAISSE }} — {{ c.ENTREPOT }}
                </option>
            </select>
            <p class="text-danger small mt-2 mb-0" *ngIf="!passationCaissesLoading && passationCaisses.length === 0">
                Aucune caisse active pour l’entrepôt de ce ticket. Vérifiez le paramétrage caisse / entrepôt.
            </p>
        </div>

        <div class="passation-modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="closePassationModal()" [disabled]="passationSubmitting || clotureSubmitting">
                Annuler
            </button>
            <button
                type="button"
                class="btn btn-outline-success"
                *ngIf="passationTicket && showClotureInitialisationAction(passationTicket)"
                (click)="clotureFromPassationModal()"
                [disabled]="clotureSubmitting || passationSubmitting">
                <span *ngIf="clotureSubmitting" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                Clôturer
            </button>
            <button
                type="button"
                class="btn btn-primary"
                (click)="confirmPassationToCaisse()"
                [disabled]="passationSubmitting || passationCaissesLoading || clotureSubmitting || !selectedPassationCaisseId">
                <span *ngIf="passationSubmitting" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                Envoyer en caisse
            </button>
        </div>
    </div>
</div>

<div style="height: 110px"></div>
